import type { ExtendedModel } from "../../../../packages/shared/src/hooks/use-extended-models";

export const COMPOUND_BETA_KIMI_MODEL_ID = "compound-beta-kimi";

export function addKimiIfCompoundPresent(
  models: ExtendedModel[],
): ExtendedModel[] {
  const compoundModel = models.find(
    (m) => m.id.includes("compound") && !m.id.includes("mini"),
  );
  return compoundModel
    ? [{ ...compoundModel, id: "compound-beta-kimi" }, ...models]
    : models;
}

export function isCompoundKimiModel(model: string) {
  return model.includes("kimi") && model.includes("compound");
}

export const compoundBetaKimiModel = {
  id: COMPOUND_BETA_KIMI_MODEL_ID,
  object: "model",
  created: 1740880017,
  owned_by: "Groq",
  active: true,
  context_window: 131072,
  public_apps: null,
  max_completion_tokens: 8192,
  features: {
    chat: true,
    tools: false,
    json_mode: true,
    max_input_images: 0,
    transcription: false,
    audio_translation: false,
    is_batch_enabled: false,
  },
  metadata: {
    display_name: "Compound Beta",
    release_stage: "preview",
    limits: {
      requests_per_minute: 15,
      requests_per_day: 200,
      tokens_per_minute: 70000,
      audio_seconds_per_hour: 1800,
      audio_seconds_per_day: 14400,
      tokens_per_day: 0,
      max_file_size: 26214400,
    },
  },
  terms_url: null,
  is_terms_required: false,
  is_terms_accepted: null,
};
